export const hasFailedRenderConditions = ({ renderConditions, props, promoNames = [] }) => {
  return (
    renderConditions &&
    renderConditions.length > 0 &&
    renderConditions.some((condition) => {
      const { type = 'default', name, value, optional } = condition

      if (value === undefined) {
        return true
      }
      if (type === 'promos') {
        return !value.find((renderConditionPromo) => promoNames.includes(renderConditionPromo))
      }
      if (type === 'validHotelProgramName') {
        return !value.includes(props.hotelProgramName)
      }

      if (typeof value === 'object') {
        if (type === 'validHotel') {
          return !value[props.hotelId]
        } else if (type === 'validGDSName') {
          if (optional && !props.gdsName) {
            return false
          }
          return !value[props.gdsName]
        }
      }

      return props[name] !== value
    })
  )
}
